"use client";

import * as React from "react";

import { Combobox, Value } from "@/components/ui/combobox";
import { Client } from "@/types/models";
import { useEffect, useState } from "react";

export function ClientFilter({
  clients,
  setClientFilter,
  defaultClient,
}: {
  clients: Client[];
  setClientFilter: (value: string) => void;
  defaultClient?: string;
}) {
  const [value, setValue] = React.useState("");

  const [clientList, setClientList] = useState<Value[]>([]);
  useEffect(() => {
    setClientList(
      clients.map((c) => {
        return {
          label: c.name,
          value: c.id,
        };
      }),
    );
    if (defaultClient) {
      setValue(defaultClient);
    }
  }, [clients, defaultClient]);

  const handleChange = (value: string) => {
    setClientFilter(value); // set the filter value in the parent component
    setValue(value);
  };

  return (
    <Combobox
      value={value}
      values={clientList}
      onChange={handleChange}
      entity="Contact"
    ></Combobox>
  );
}
